<template>
  <section v-if="!!actionLogs.length" v-loading="loading" class="action-logs-review-component">
    <div class="logs">
      <ActionLogSection
        v-if="wipVersion"
        class="action-log-section"
        :game-id="gameId"
        :version="wipVersion"
        :logs="actionLogs"
        no-title
      />
      <div v-else><em>Version not found</em></div>
    </div>

    <div v-if="hasNextPage" class="pagination" @click="loadMore">Show more change logs</div>
  </section>
  <div v-else-if="!actionLogs.length && !loading" class="warning-message">
    No changes are made on this version...
    <br />
    Are you sure you want to publish an empty version?
  </div>
</template>

<script setup lang="ts">
import { computed, PropType, watchEffect } from "vue";

import ActionLogSection from "@/components/ActionLogSection/ActionLogSection.vue";
import { ActionLogsReviewVersionFragment, useActionLogsReviewQuery, useRelayConnection } from "@/graphql";

const props = defineProps({
  gameId: {
    type: String,
    required: true,
  },

  actionLogs: {
    type: Array as PropType<ActionLogsReviewVersionFragment[]>,
    default: () => [],
  },
});

const emit = defineEmits(["update:actionLogs"]);

/**
 * Load all the logs
 */
const { result, loading, fetchMore } = useActionLogsReviewQuery(
  { gameId: props.gameId, first: 5 },
  { fetchPolicy: "network-only" }
);

/**
 * All version of the game
 */
const wipVersion = computed(() => result.value?.game?.version);

const {
  list: actionLogs,
  hasNextPage,
  loadMore,
} = useRelayConnection(fetchMore, result, (res) => res?.game?.actionLogs);

watchEffect(() => {
  emit("update:actionLogs", actionLogs.value);
});
</script>

<style lang="scss" scoped>
.action-logs-review-component {
  .logs {
    margin-bottom: size("L");
    text-align: left;
    animation: fade-in 1s ease-in;
  }
  .pagination {
    display: flex;
    flex-direction: column;
    box-sizing: border-box;
    width: 100%;
    height: 100px;
    margin-top: -80px;
    justify-content: flex-end;
    background: linear-gradient(
      0deg,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 50%,
      rgba(255, 255, 255, 0) 98%
    );
    position: relative;
    z-index: 9999;
    border: 1px solid var(--vd-color-grey-light-7);
    border-top: 0px solid transparent;
    padding-bottom: 10px;
    margin-bottom: size("L");

    color: var(--vd-base-primary-color);
    cursor: pointer;
  }
}

.warning-message {
  color: var(--vd-color-yellow);
}
</style>
